import * as React from "react";
import {cx} from "emotion";

import "./multi-column-value-table.scss";

import {cs}          from "@Common/react/chain-services";
import {keyed}       from "@Common/react/keyed";
import {createArray} from "@Common/utils/collections";

export const MultiColumnValueTable = ({header, list}) => cs(
    ["columns", (_, next) => next(list.length > 6 ? (
        [
            list.slice(0, Math.ceil(list.length/2)),
            list.slice(Math.ceil(list.length/2))
        ]
    ) : (
        [list]
    ))],
    ({columns}) => (
        <table className="multi-column-value-table-7nx">
            <colgroup>
                {...columns.map(() => [
                    <col width="1%"/>,
                    <col width="1%"/>,
                ]).flat()}
            </colgroup>
            <thead>
            <tr>
                {...columns.map(() => [
                    <th {...{
                        "xd-qa-type": "label",
                        "xd-qa-name": header.labelHeader,
                    }}>
                        {header.labelHeader}
                    </th>,
                    <th {...{
                        "xd-qa-type": "label",
                        "xd-qa-name": header.valueHeader,
                    }}>
                        {header.valueHeader}
                    </th>,
                ]).flat()}
            </tr>
            </thead>

            <tbody>
            {createArray(Math.max(...columns.map((list) => list.length))).map((rowIndex) => cs(
                keyed(rowIndex),
                () => (
                    <tr>
                        {...columns.map((list, listIndex) => {
                            const item = list[rowIndex];
                            if (!item) {
                                return [<td/>,<td/>];
                            }
                            const {label, value} = item;
                            return [
                                <td {...{
                                    "xd-qa-type": "label",
                                    "xd-qa-name": label,
                                }}>
                                    {label}
                                </td>,
                                <td {...{
                                    className: cx({"border-right": columns.length > 1 && listIndex===0}),
                                    "xd-qa-type": "text",
                                    "xd-qa-name": label,
                                }}>
                                    {value}
                                </td>,
                            ];
                        }).flat()}
                    </tr>
                )
            ))}
            </tbody>
        </table>
    ),
);
